var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.updateExists)?_c('button',{staticClass:"btn btn-update-exists",on:{"click":_vm.refreshApp}},[_c('strong',[_vm._v("New version available!")]),_c('br'),_vm._v(" Click to update ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }